module.exports = __webpack_public_path__ + "static/media/Agri-Storage Entrepreneur Infographic Desktop 07-02-2023 C.c5e14a23.gif";